<template lang="pug">
.k-nav-main.desktop-only( :class='classes' )
  .tray( ref='tray' :class=`{ open: program }` )
    d-program-preview.tray(
      v-if='program'
      :program='program'
    )
  nav.main(
    role='navigation'
    ref='navbar'
    @mousemove='scrollMenu'
  )
    w-btn-icon.menu-toggle(
      href='#'
      :no-hover='!menuHover'
      size='xl'
      aria-label='Toggle Navigation'
      @click.prevent='toggleMenu'
    )
      transition( name='fade-super-fast' mode='out-in' )
        i-down(
          v-if='menuOpen'
          key='close'
          title='Close menu'
        )
        i-menu(
          v-else
          key='menu'
          title='Featured programmes'
        )
    .menu
      .bg( :style='{ left: `${bgOffset}px` }' )
      .inner( ref='menu' :style='{ left: `${menuOffset}px` }' )
        router-link.menu-item(
          v-for='( item, index ) in menu'
          v-hover-intent='displayProgram'
          :key='index'
          :class='[ slug( item ), { hover: program === item }]'
          :to='item.url'
          @mouseover.native='setCurrentItem( item )'
          @click.native='closeMenu'
        )
          img( :src='item.thumb' )
</template>

<script lang="js">
import { mapState } from 'vuex'
import WBtnIcon from '@/widgets/w-btn-icon'
import DProgramPreview from '@/displays/d-program-preview'
import IMenu from 'icons/Menu'
import IDown from 'icons/ChevronDown'
import { Logger } from '@/lib/logger'

export default {
  name: 'MainNavBlock',
  mixins: [],
  components: { WBtnIcon, DProgramPreview, IMenu, IDown },
  props: {
    menu: {
      type: Array,
      default: () => []
    },
    logo: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      menuOpen: false,
      menuHover: true,
      program: null,
      currentHover: null,
      menuOffset: 0,
      bgOffset: 0,
    }
  },
  created() {},
  mounted() {},
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen
      if ( this.menuOpen ) {
        this.menuHover = false
      } else {
        this.currentHover = null
        this.program = null
        setTimeout(() => { this.menuHover = true }, 1000 )
      }
    },
    closeMenu() {
      this.menuOpen = false
      this.currentHover = null
      this.program = null
    },
    setCurrentItem( item ) {
      // Logger.debug( 'setCurrentItem', '<MainNavBlock>', item )()
      this.currentHover = item
    },
    slug( item ) {
      var slug = item.url
      if ( slug === '/' ) return 'home'
      if ( slug.startsWith('/') ) {
        slug = slug.substr(1)
      }
      if ( slug.endsWith('/') ) {
        slug = slug.slice( 0, -1 )
      }
      return slug
    },
    displayProgram() {
      this.program = this.currentHover
    },
    scrollMenu( $event ) {
      if ( !this.menuOpen || !this.$refs.navbar || !this.$refs.menu ) return
      const bar = this.$refs.navbar
      const menu = this.$refs.menu
      const w = bar.offsetWidth
      const mw = menu.offsetWidth
      const mh = menu.offsetHeight
      const px = $event.pageX
      const x = px < mh / 4 ? mh / 4 : px > w - mh / 4 ? w - mh / 4 : px
      // Logger.debug( 'scrollMenu', '<MainNavBlock>', { w, mw, x })()
      this.menuOffset = mh / 2 - ( x + mh / 2 ) / ( w + mh ) * ( mw + mh - w )
      this.bgOffset = -200 + mh / 2 - ( x + mh / 2 ) / ( w + mh ) * ( mw + mh - w ) * 0.5
    },
  },
  computed: {
    classes() {
      return {
        open: this.menuOpen
      }
    }
  },
  watch: {
    'slider.open' ( val ) {
      this.menuOpen = val
    }
  }
}
</script>

<style lang="scss">
@import "@/scss/breakpoint";

.k-nav-main {
  z-index: 10;
  position: fixed;
  bottom: 0;
  width: 100%;
  margin: 0 !important;
  nav.main {
    position: absolute;
    height: var(--h-nav-main);
    width: 100%;
    transition: all 400ms;
    bottom: calc( -1 * var(--h-nav-main));
    .menu-toggle {
      position: absolute;
      right: var(--s-base);
      top: calc( -1 * var(--s-3xl) );
      z-index: 2;
    }
    .bg {
      background: url(../assets/bg-fancy-6.png) top center repeat-x;
      position: absolute;
      bottom: 0;
      height: calc( var(--h-nav-main) + var(--s-xl));
      width: 300vw;
      pointer-events: none;
    }
    .menu {
      display: inline-block;
      .inner {
        /* transition: all 150ms ease-in-out; */
        position: relative;
        display: flex;
      }
      .menu-item {
        flex: 0 0 var(--h-nav-main);
        height: var(--h-nav-main);
        width: var(--h-nav-main);
        box-sizing: border-box;
        padding: var(--s-sm);
        img {
          width: 100%;
          position: relative;
          transition: all 250ms cubic-bezier(0.2, 3, 0.8, 1);
          top: 0;
        }
        &:hover img {
          box-shadow: 0 0px 3px rgba(255,160,0,0.75);
          box-shadow: 0 150px 70px rgba(255,160,0,0.75);
          border-bottom: 1px solid rgba(255,180,80,0.85);
          border-radius: 8px;
          top: -20px;
        }
      }
    }
  }
  .tray {
    position: absolute;
    height: 100vh;
    width: 100vw;
    transition: top 800ms, opacity 400ms;
    top: 0;
    opacity: 0;
    background: rgba(0,0,0,0.5);
    &.open {
      top: -100vh;
      opacity: 1;
      transition: top 250ms, opacity 500ms;
    }
  }
  &.open {
    nav.main {
      bottom: 0;
    }
  }
}
</style>
